import Icon from '../components/Icon.vue'

Icon.register({"dolly":{"width":576,"height":512,"paths":[{"d":"M294.2 277.7C312.2 282.7 328.9 291.1 343.7 302.4L505.2 248.6C513.6 245.8 518.1 236.7 515.3 228.4L454.9 47.2C452.1 38.8 443 34.3 434.7 37.1L373.6 57.5 406.7 156.9 346 177 312.9 77.6 251.3 98.1C242.9 100.9 238.4 110 241.2 118.3L294.2 277.7zM575.2 326.4L565 296C562.2 287.6 553.1 283.1 544.8 285.9L331.3 357.1C314.1 335.1 287.7 320.7 257.8 320.1L158.4 21.9C154 8.8 141.8 0 128 0H16C7.2 0 0 7.2 0 16V48C0 56.8 7.2 64 16 64H104.9L197.1 340.7C171 361.1 155.4 394.3 161.1 431.2 167.2 470.6 199 503.5 238.4 510.4 298.6 521.1 350.7 475.6 351.8 417.8L565.1 346.6C573.4 343.8 578 334.8 575.2 326.4zM256 464C229.5 464 208 442.5 208 416S229.5 368 256 368 304 389.5 304 416 282.5 464 256 464z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/dolly.js
// module id = null
// module chunks = 